const GaauManagersEnum = [
    "Plantio árvore de PP",
    "Plantio árvore de MP",
    "Plantio árvore de GP",
    "Poda de Condução",
    "Poda de Limpeza",
    "Poda de Levantamento de copa",
    "Poda de Redução de Copa",
    "Aumentar área livre",
    "Desenterrar o colo",
    "Retirar erva de passarinho",
    "Tratamento de cavidade",
    "Realizar tomografia e/ou penetografia",
    "Supressão/Substituição",
    "Monitoramento",
    "Realizar adubação",
    "Colocar protetor de colo",
    "Ancoragem de condução"
  ];

export default GaauManagersEnum;
